import { RefObject, useEffect, useRef, useState } from "react";
import { FaStar, FaShare, FaFacebookSquare, FaLink, FaLinkedin, FaEye,FaRegThumbsUp,FaThumbsUp,FaHeart,FaRegHeart} from "react-icons/fa";
import { IoIosSave } from "react-icons/io";
import { HiDotsVertical } from "react-icons/hi";
import { Form, Popover, Overlay} from "react-bootstrap";
import { MdEdit } from "react-icons/md";
import { Rating } from "react-simple-star-rating";
import { useContext } from "react";
import VideoContext from "../../store/video-context";
import { toast } from "react-toastify";
import { FacebookShareButton, LinkedinShareButton } from "react-share";

// import { FacebookIcon, TwitterIcon, LinkedinIcon } from "react-share";

const VideoDescription = (props: any) => {
  const vContext = useContext(VideoContext);
  const [edit, setEdit] = useState(false);
  const [rating, setRating] = useState(props.videoData.rating.rating);
  const [videoData, setVideoData] = useState(props.videoData.txData[0]);
  const descTextareaRef = useRef() as RefObject<HTMLTextAreaElement>;
  const [show, setShow] = useState(false);
  const [fav, setFav] = useState(props.videoData.favorite);
  const [like, setLike] = useState(props.videoData.like);
  const [likeCount, setLikeCount] = useState(props.videoData.likeCount);
  const [displaylikeCount, setDisplayLikeCount] = useState('');
  const [feed, setFeed] = useState(props.videoData.rating.feedback);
  const target = useRef(null);
var curLikeCount = props.videoData.likeCount;
  useEffect(() => {

    if(curLikeCount>50)
  setDisplayLikeCount(likeCount);




  }, []);

  
  const handleEdit = () => {
    setEdit(!edit);
    // console.log("textareaRef", descTextareaRef.current)
    if (
      edit &&
      videoData.transmission_patient_details !== descTextareaRef.current!.value
    ) {
      editTxDetailApiHandler(descTextareaRef.current!.value);
    }
  };

  const editTxDetailApiHandler = (description: any) => {
    description.replace(/\n/gi, "<br>");
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=editTxDetail&transID=" +
        vContext.transId +
        "&txDetail=" +
        description
    )
      .then((res) => res.json())
      .then((responseData) => {
        // console.log('responseData',responseData);
        if (responseData.status === "success") {
          // console.log("data saved succesfully!");
          setVideoData((preData: any) => {
            return { ...preData, transmission_patient_details: description };
            // return {...preData, [0]: {...preData[0], transmission_patient_details: description}}
          });
          toast.dark("Video Detail Updated Successfully!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.dark("Video Detail Update Failed!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          // console.log("Fail edit details");
        }
      })
      .catch((error) => {
        console.error("Error:(editTxDetailApiHandler)", error);
      });
  };

  const likeTx= () => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=likeTx&transID=" +
        vContext.transId +
        "&userID=" +
        vContext.userId 
    )
      .then((response) => response.json())
      .then((data) => {
        // console.log('Success Rating:', data);
        setLike(true);
        setLikeCount(parseInt(likeCount)+1);
        curLikeCount=parseInt(likeCount)+1;
        if(curLikeCount>50)
        setDisplayLikeCount(curLikeCount);
       
      })
      .catch((error) => {
        console.error("Error:(handlerRating)", error);
      });
  };

  const removelikeTx= () => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=removelikeTx&transID=" +
        vContext.transId +
        "&userID=" +
        vContext.userId 
    )
      .then((response) => response.json())
      .then((data) => {
        // console.log('Success Rating:', data);
        setLike(false);
        
        setLikeCount(parseInt(likeCount)-1);
        curLikeCount=parseInt(likeCount)-1;
        if(curLikeCount>50)
        setDisplayLikeCount(curLikeCount);
      })
      .catch((error) => {
        console.error("Error:(handlerRating)", error);
      });
  };
  const addToFav= () => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=addToFav&transID=" +
        vContext.transId +
        "&userID=" +
        vContext.userId 
    )
      .then((response) => response.json())
      .then((data) => {
        // console.log('Success Rating:', data);
        setFav(true);
       
      })
      .catch((error) => {
        console.error("Error:(handlerRating)", error);
      });
  };

  const removeFav= () => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=removeFav&transID=" +
        vContext.transId +
        "&userID=" +
        vContext.userId 
    )
      .then((response) => response.json())
      .then((data) => {
        // console.log('Success Rating:', data);
        setFav(false);
      })
      .catch((error) => {
        console.error("Error:(handlerRating)", error);
      });
  };


    
  const handleRating = (rate: any) => {
    // feedback value is hardcoded
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=rateTx&transID=" +
        vContext.transId +
        "&userID=" +
        vContext.userId +
        "&score=" +
        rate +
        "&feedback=" +
        feed
    )
      .then((response) => response.json())
      .then((data) => {
        // console.log('Success Rating:', data);
        if (data.status === "success") {
          toast.dark("Rating Saved!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          vContext.setRatingHandler(rate);
          setRating(rate);
        } else {
          toast.dark("Rating Failed!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          // console.log("Fail rating")
        }
      })
      .catch((error) => {
        console.error("Error:(handlerRating)", error);
      });
  };

  const copyLink = () => {
    // "https://lapguru.com/react-build/?trans_id="+vContext.transId
    navigator.clipboard.writeText(
      window.location.origin + "/player/?trans_id=" + vContext.transId
    );
    toast.dark("Link Copied!", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  //   const hideModal = () => {
  //     setShow(false);
  //   };

  //   const openModal = () => {
  //     setShow(true);
  //   };

  const handleSubmit = (event: any) => {
    console.log("yes",feed);

    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    let data: { [index: string]: any } = { command: "rateTx" };
    data.userID = vContext.userId;
    data.transID = vContext.transId;
    data.score = rating;
    data.feedback = feed ;

    console.log(JSON.stringify(data),"yes11");
      fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
      //JSON.stringify({a: 1, b: 'Textual content'})     
    }).then((res) => res.json())
      .then((response) => {
              console.log("response rating feedback", response);
              if (response.status === "success") {
                setFeed(feed);
                console.log("ratings and feedback added")
                toast.dark(
                  "Thank you for your feedback!",
                  {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  }
                );
              } else {
                // console.log("product enquiry failed");
                toast.dark("Something went wrong!", {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }

            })
            .catch((error) => {
              console.error("Error:(ratingerror)", error);
            });
    setShow(false);

  };

  const feedbackPopover = (
    <Popover id="feedbackpopup" placement="top" className="star-rating-popup">
      <div>
        <div className="rating-container">
          <Rating
            size={20}
            onClick={handleSubmit}
            ratingValue={rating}
            className="star-rating-container"
          >
            <div>
              <FaStar size={20} className="rating-star" />
            </div>
          </Rating>
        </div>

        <Form id="feedback" onSubmit={handleSubmit}>
          <Form.Control
            as="textarea"
            id="feedback"
            rows={2}
          onChange={(e: any) => setFeed(e.target.value)}
        
          />
          <Form.Control
            type="submit"
            className="btn btn-primary"
            style={{ float: "right" }}
            id="submit"
            value="Submit"
          />
        </Form>
      </div>
    </Popover>
  );

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div className="video-description">
      <div className="video-description-header d-md-flex">
        <div className="video-doctor-details col-lg-5 col-md-5 col-sm-12 p-0">
          <div className="video-doctor-img">
            <img src={"../" + videoData.tx_surgeon_photo} alt="" />
          </div>
          <div className="video-doctor-name-box">
            <div className="mb-1 video-doctor-name">
              {videoData.tx_surgeon_name}
            </div>
            <div className="video-doctor-designation">
              {/* Naval Multispeciality Hospital */}
              {videoData.surgeon_hospital_name}
            </div>
          </div>
        </div>
        <div className="video-share-details pt-2 pt-md-0">
          {props.videoData.txData[0].transmission_status !== "0" && (
            <div className="mr-3 d-flex align-items-center">
              <FaEye className="mr-1" size={16} />
              {vContext.viewCount
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
              {/* views */}
            </div>
          )}
          {vContext.isAdmin && (
            <div
              className="mr-3 d-flex align-items-center edit-btn"
              onClick={handleEdit}
            >
              {!edit ? (
                <>
                  <MdEdit className="mr-1" size={16} /> Edit{" "}
                </>
              ) : (
                <>
                  <IoIosSave className="mr-1" size={16} /> Save
                </>
              )}
            </div>
          )}
          <div className="step-6 d-flex align-items-center">
            {/* <OverlayTrigger
              trigger={["hover", "focus"]}
              placement="top"
              overlay={feedbackPopover}
            >
              <div
                className="mr-3 d-flex align-items-center star-rating"
                //   onClick={openModal}
              >
                <FaStar className="mr-1" /> Leave a Rating
              </div>
            </OverlayTrigger> */}
            {vContext.userId=="1" ? (
              <>
                {!like ? (
                <>
                <div
              className="mr-3 d-flex align-items-center star-rating"
              ref={target}
              //onClick={() => setShow(!show)}
              onClick={() => likeTx()}
              //   onClick={openModal}
            >
                 <FaRegThumbsUp className="mr-1" style={{fontSize:"15px"}} /> {likeCount} Likes
                 </div>
                </>
              ) : (
                <>
                <div
              className="mr-3 d-flex align-items-center star-rating"
              ref={target}
              //onClick={() => setShow(!show)}
              onClick={() => removelikeTx()}
              //   onClick={openModal}
            >
                   <FaThumbsUp className="mr-1" style={{fontSize:"15px"}} /> {likeCount} Likes
                   </div>
                </>
              )}
              </>
            ):(
              <>
               {!like ? (
                <>
                <div
              className="mr-3 d-flex align-items-center star-rating"
              ref={target}
              //onClick={() => setShow(!show)}
              onClick={() => likeTx()}
              //   onClick={openModal}
            >
                 <FaRegThumbsUp className="mr-1" style={{fontSize:"15px"}} /> {displaylikeCount}  {displaylikeCount ? (<>likes</>):(<>like</>)}
                 </div>
                </>
              ) : (
                <>
                <div
              className="mr-3 d-flex align-items-center star-rating"
              ref={target}
              //onClick={() => setShow(!show)}
              onClick={() => removelikeTx()}
              //   onClick={openModal}
            >
                   <FaThumbsUp className="mr-1" style={{fontSize:"15px"}}/> {displaylikeCount} {displaylikeCount ? (<>likes</>):(<>like</>)}
                   </div>
                </>
              )}
              </>
              )}
             
            
            <Overlay
              target={target.current}
              show={show}
              placement="top"
              rootClose={true}
              onHide={handleClose}
            >
              <Popover
                id="feedbackpopup"
                placement="top"
                className="star-rating-popup"
              >
                <div>
                  <div className="rating-container">
                    <Rating
                      size={20}
                      onClick={handleRating}
                      ratingValue={rating}
                      className="star-rating-container"
                    >
                      <div>
                        <FaStar size={20} className="rating-star" />
                      </div>
                    </Rating>
                  </div>

                  <Form id="feedback" onSubmit={handleSubmit}>
                    <Form.Control
                      as="textarea"
                      id="feedback"
                      rows={2}
                      onChange={(e: any) => setFeed(e.target.value)}
                      placeholder={feed !== "undefined" && feed}
                    />
                    
                    <Form.Control
                      type="submit"
                      className="btn btn-primary"
                      style={{ float: "right" }}
                      id="submit"
                      value="Submit"
                    />

                  </Form>
                </div>
              </Popover>
            </Overlay>

            {!fav ?
            (
              <>
              <div
              className="mr-3 d-flex align-items-center star-rating"
              ref={target}
              //onClick={() => setShow(!show)}
              onClick={() => addToFav()}
              //   onClick={openModal}
            >
                   <FaRegHeart className="mr-1" style={{fontSize:"15px"}}  /> Favorite
                   </div>
              </>
            )
            :
            (
              <>
              <div
              className="mr-3 d-flex align-items-center star-rating"
              ref={target}
              //onClick={() => setShow(!show)}
              onClick={() => removeFav()}
              //   onClick={openModal}
            >
                   <FaHeart className="mr-1" style={{fontSize:"15px"}} /> Favorite
                   </div>
              </>
            )}
            
            <div className="d-flex align-items-center share-popover">
              <FaShare className="mr-1" /> Share
              <div className="share-popover-popup">
                <div className="share-popover-item">
                  {/* <FaFacebookSquare size={20} /> */}
                  <FacebookShareButton
                    url={
                      window.location.origin +
                      "/player/?trans_id=" +
                      vContext.transId
                    }
                  >
                    <FaFacebookSquare size={20} />
                  </FacebookShareButton>
                </div>
                {/* <div className="share-popover-item">
                        <IoLogoWhatsapp size={20} />
                        </div> */}
                <div className="share-popover-item">
                  {/* <FaTwitterSquare size={20} /> */}
                  <LinkedinShareButton
                    url={
                      window.location.origin +
                      "/player/?trans_id=" +
                      vContext.transId
                    }
                  >
                    <FaLinkedin size={20} />
                  </LinkedinShareButton>
                </div>
                <div className="share-popover-item">
                  <FaLink size={20} onClick={copyLink} />
                </div>
              </div>
            </div>


          {/*<div className="d-flex align-items-center share-popover" style={{marginLeft:"7px"}}>
            <HiDotsVertical></HiDotsVertical>speed
              <div className="share-popover-popup">
                <div className="share-popover-item">
                 
                 0.50x
                </div>
                
                <div className="share-popover-item">
                 
                  0.75x
                </div>
                <div className="share-popover-item">
                 2x
                </div>
              </div>
            </div>
            */}


          </div>
        </div>
      </div>
      <div className="video-description-body">
        {
          edit ? (
            <textarea className="form-control" ref={descTextareaRef}>
              {videoData.transmission_patient_details.replace(/<br>/gi, "\n")}
            </textarea>
          ) : (
            <div>
              <ul>
                {videoData.transmission_patient_details
                  .replace(/\*/gi, "")
                  .split("\n")
                  .map((item: any) => {
                    return <li dangerouslySetInnerHTML={{ __html: item }}></li>;
                  })}
              </ul>
            </div>
          )
          // <div dangerouslySetInnerHTML={{__html:videoData.transmission_patient_details}}></div>
        }
      </div>
    </div>
  );
};

export default VideoDescription;
